import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import axios from "axios"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


const Products = () => {

    useEffect(() => {
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("prdct");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("prdcts");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []); // Empty dependency array ensures this effect runs only once

    const [users, setUsers] = useState([]);
    useEffect(() => {
        getUsers();
    }, []);

    function getUsers() {
        axios.get('https://react-apis.dotlocalhost.com/productShow.php').then(function(response) {
            console.log(response.data);
            setUsers(response.data);
        });
    }

    const deleteUser = (id) => {
        axios.delete(`https://react-apis.dotlocalhost.com/productShow.php/${id}/delete`).then(function(response){
            console.log(response.data);
            alert('Record have been daleted succefully!');
            getUsers();
        });
    }

    return(
        <div class="wrapper">
            <Sidebar/>
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Products</h3>
                        </div>
                    </div>

                    <Table striped bordered hover style={{fontSize: '12px'}}>
                        <thead>
                            <tr style={{textAlign:'center', backgroundColor:'#C0D4D9', color:'#000000'}}>
                                <th>#</th>
                                <th>Date</th>
                                <th>Product Name</th>
                                <th>Packing</th>
                                <th>Net Weight</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody style={{padding: "3px", textAlign: "left"}}>
                            {users.map((user, key) =>
                                <tr key={key}>
                                    <td style={{textAlign:'center'}}>{user.id}</td>
                                    <td>{user.date}</td>
                                    <td>{user.productName}</td>
                                    <td>{user.packing}</td>
                                    <td style={{textAlign:'right', paddingRight:'3%'}}>{user.netWeight} Kg</td>
                                <td>
                                    <Link to={`/edit-products/${user.id}`} style={{marginRight: "10px", marginRight: "10px", fontSize:"10px"}} class="btn btn-warning">Edit Product</Link>
                                    <button onClick={() => deleteUser(user.id)} style={{marginRight: "10px", marginRight: "10px", fontSize:"10px"}} class="btn btn-danger">Delete</button>
                                </td>
                                </tr>
                            )}

                        </tbody>
                    </Table>

                </div>

            </div>          
        </div>
    )
}

export default Products;